import { Platform } from 'react-native';
import { CoreRoutes } from '../Coordinator/Coordinator/CoreRoutes';
import { EmptyScreenView } from '../Screens/EmptyScreen/EmptyScreenView';
import { ErrorScreenView } from '../Screens/ErrorScreen/ErrorScreenView';
import { LoadingScreenView } from '../Screens/LoadingScreen/LoadingScreenView';
import { PopUpScreenView } from '../Screens/PopUpScreen/PopUpScreenView';
import { NotificationsPermissionScreenComponent } from '../Screens/NotificationsPermissionScreen/NotificationsPermissionScreenComponent';
import { PushNotificationScreenComponent } from '../Screens/PushNotificationScreen/PushNotificationScreenComponent';
import { ShareScreenComponent } from '../Screens/ShareScreen/ShareScreenComponent';
import { AppUpdateScreenComponent } from '../Screens/AppUpdateScreen/AppUpdateScreenComponent';
const screenOptions = {
    headerShown: false,
    presentation: 'transparentModal'
};
export const CoreScreens = [
    {
        name: CoreRoutes.empty,
        component: EmptyScreenView,
        options: Object.assign(Object.assign({}, screenOptions), { animation: 'none' })
    },
    {
        name: CoreRoutes.popUp,
        component: PopUpScreenView,
        options: screenOptions
    },
    {
        name: CoreRoutes.error,
        component: ErrorScreenView,
        options: screenOptions
    },
    {
        name: CoreRoutes.loading,
        component: LoadingScreenView,
        options: screenOptions
    },
    {
        name: CoreRoutes.notificationsPermissions,
        options: {
            presentation: Platform.select({
                default: undefined,
                web: 'transparentModal'
            })
        },
        component: NotificationsPermissionScreenComponent
    },
    {
        name: CoreRoutes.share,
        component: ShareScreenComponent,
        options: screenOptions
    },
    {
        name: CoreRoutes.pushNotification,
        options: screenOptions,
        component: PushNotificationScreenComponent
    },
    {
        name: CoreRoutes.appUpdate,
        component: AppUpdateScreenComponent
    },
];
